/**
 * Application constants.
 */

/**
 * GitHub repository slug.
 */
export const REPOSITORY_SLUG = "jakejarvis/domainstack.io";

/**
 * Apple Shortcut ID for the iOS shortcut.
 */
export const APPLE_SHORTCUT_ID = "fa17677a0d6440c2a195e608305d6f2b";

/**
 * Maximum number of domain suggestions/history items to show in the UI.
 */
export const MAX_HISTORY_ITEMS = 10;
